import { get, patch, post, remove } from '@/api/base'

const identifiersApi = {
  get: async (containerUuid, identifierUuid) => {
    const response = await get({
      path: `containers/${containerUuid}/identifiers/${identifierUuid}`,
    })
    return response.success ? response.data.identifier : null
  },
  delete: async (containerUuid, identifierUuid) => {
    return await remove({
      path: `containers/${containerUuid}/identifiers/${identifierUuid}`,
    })
  },
  create: async (containerUuid, params) => {
    return await post({
      path: `containers/${containerUuid}/identifiers`,
      params: { ...params },
    })
  },
  update: async (containerUuid, identifierUuid, params) => {
    return await patch({
      path: `containers/${containerUuid}/identifiers/${identifierUuid}`,
      params: { ...params },
    })
  },
}

export default identifiersApi
